/* eslint-disable import/no-cycle */
import {action, decorate, observable} from 'mobx';
import {Api} from '../middleware/api';
import {EntityStore} from './entityStore';
import {InspectionLot} from '../models/inspectionLot';
import {loadInspectionLotsEndpoint, WorkplacesApi} from '../middleware/endpoints/workplaces';

export class InspectionLotStore extends EntityStore {
  inspectionLots = [];

  constructor(rootStore) {
    super(rootStore, 'inspectionLots', Api.inspectionLot, InspectionLot, true);
  }

  getDependencies() {
    return [
      {
        store: this.rootStore.orderStore,
        modelId: 'orderId',
      },
    ];
  }

  searchByNo({params}) {
    return this.api.search(params).then((response) => response.data);
  }

  deactivate(id, reason) {
    return this.api.deactivate({id, reason})
      .then(() => {
        this.load(id);
        this.rootStore.inspectionTaskPendingStore.loadByWorkplace(this.rootStore.workplaceStore.selectedWorkplace.id);
        this.addMessage({type: 'success', title: 'flashMessages.deactivateSuccess'},
          {skipNotification: false});
      }).catch((e) => this.handleApiError(e, 'deactivate'));
  }

  reactivate(id) {
    return this.api.reactivate({id})
      .then(() => {
        this.load(id);
        this.addMessage({type: 'success', title: 'flashMessages.reactivateSuccess'},
          {skipNotification: false});
      }).catch((e) => this.handleApiError(e, 'reactivate'));
  }

  loadValidByWorkplace(workplaceId, validFrom, validTo) {
    return this.loadAllWithDependencies({
      api: WorkplacesApi,
      apiEndpoint: loadInspectionLotsEndpoint,
      action: 'load-by-workplace',
      params: {
        id: workplaceId,
        validFrom: validFrom.toISOString(),
        validTo: validTo.toISOString(),
      },
    });
  }

  reload(fields) {
    return this.api.reload(fields);
  }
}

decorate(InspectionLotStore, {
  inspectionLots: observable,
  deactivate: action,
  reactivate: action,
  loadByDateRange: action,
});
